import { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import 'bootstrap/dist/css/bootstrap.min.css';

const navlinks = [{
    id: 1,
    link: "home",
    label: "Accueil"
}, {
    id: 2,
    link: "sommaire",
    label: "Sommaire"
}];

export const NavBar = () => {
    const [activeLink, setActiveLink] = useState('home');
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        }
        window.addEventListener("scroll", onScroll);

        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const onUpdateActiveLink = (value) => {
        setActiveLink(value);
    };

    return (
        <Navbar expand="lg" className={scrolled ? "scrolled" : ""}>
            <Container>
                <Nav className="mx-auto">
                    {navlinks.map(navlink => (
                        <Nav.Link
                            key={navlink.id}
                            href={"#" + navlink.link}
                            className={activeLink === navlink.link ? 'active navbar-link' : 'navbar-link'}
                            onClick={() => onUpdateActiveLink(navlink.link)}
                        >
                            {navlink.label}
                        </Nav.Link>
                    ))}
                </Nav>
            </Container>
        </Navbar>
    );
};
